import React from 'react';
import { motion } from 'framer-motion';
const layers = [{
  num: '1',
  title: 'SACIA FÍSICAMENTE',
  subtitle: 'Proteína + Fibra',
  desc: "Suprime la grelina (hormona del hambre). Resultado: el estómago manda señal de 'ya estoy lleno'.",
  color: 'bg-[#2D6A4F]' // Medium green
}, {
  num: '2',
  title: 'SATISFACE EMOCIONALMENTE',
  subtitle: 'Sabor real, rico, placentero',
  desc: 'Activa dopamina y serotonina de forma natural. Resultado: el cerebro recibe su recompensa.',
  color: 'bg-[#1B4332]' // Dark green
}, {
  num: '3',
  title: 'ESTABILIZA BIOLÓGICAMENTE',
  subtitle: 'Glucosa balanceada',
  desc: 'Sin pico de insulina post-snack. Resultado: el antojo no regresa en 20 minutos.',
  color: 'bg-[#0F291E]' // Darker green
}];
export function OriginStory() {
  return <section className="py-24 px-4 bg-brand-dark text-brand-cream relative" data-id="element-142">
      <div className="absolute inset-0 bg-leaf-pattern opacity-20 pointer-events-none" data-id="element-143" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6 text-lg text-brand-cream/90 mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-brand-gold mb-8 text-center" data-id="element-146">
            El "Aha Moment"
          </h2>
          <p data-id="element-147">Hace un par de años, yo estaba exactamente donde tú estás.</p>
          <p data-id="element-148">
            Comiendo "bien" el 90% del tiempo... y siendo víctima del antojo el
            10% restante que arruinaba todo. Me sentía una hipócrita. Les decía
            a todos que comía saludable. Y lo hacía — hasta las 3pm.
          </p>
          <p className="font-medium text-brand-lightGold text-xl" data-id="element-149">
            Ese momento de las tardes era mi kryptonita.
          </p>
          <p data-id="element-150">
            Un día, en vez de luchar contra el antojo, decidí estudiarlo. Leí
            sobre la grelina, sobre el cortisol, sobre los mecanismos biológicos
            del hambre hedónica.
          </p>
          <p className="text-2xl font-heading text-center py-8 text-brand-gold" data-id="element-151">
            "El antojo no se vence. Se responde."
          </p>
          <p data-id="element-152">
            Descubrí que había 3 capas que, combinadas, apagaban el antojo de
            forma consistente:
          </p>
        </motion.div>

        <div className="space-y-6 relative" data-id="element-153">
          {/* Connecting line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-brand-gold/20 -translate-x-1/2 hidden md:block" data-id="element-154" />

          {layers.map((layer, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className={`relative z-10 p-8 rounded-2xl border border-brand-gold/20 shadow-xl ${layer.color} md:w-[80%] ${index % 2 === 0 ? 'md:mr-auto' : 'md:ml-auto'}`} data-id="element-155">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6" data-id="element-156">
                <div className="w-16 h-16 rounded-full bg-brand-gold text-brand-dark flex items-center justify-center font-bold text-2xl flex-shrink-0 shadow-lg" data-id="element-157">
                  {layer.num}
                </div>
                <div data-id="element-158">
                  <h3 className="text-xl font-bold text-brand-lightGold mb-1" data-id="element-159">
                    CAPA {layer.num}: {layer.title}
                  </h3>
                  <p className="text-brand-cream font-medium mb-3" data-id="element-160">
                    → {layer.subtitle}
                  </p>
                  <p className="text-brand-cream/80 text-sm leading-relaxed" data-id="element-161">
                    {layer.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center mt-16 text-xl text-brand-cream/90" data-id="element-162">
          <p data-id="element-163">Con ese método desarrollé 25 recetas.</p>
          <p className="mt-4" data-id="element-164">
            Cada una diseñada para un tipo específico de antojo. Cada una lista
            en menos de 10 minutos. Cada una con ingredientes que ya tienes o
            que consigues en cualquier tienda.
          </p>
        </motion.div>
      </div>
    </section>;
}